export enum Frequency {
	Minute = "minute",
	Hour = "hour",
	Daily = "daily",
	Weekly = "weekly",
	Monthly = "monthly",
}

export enum Occurrence {
	OneTime = "ONE-TIME",
	Recurring = "RECURRING",
}

export enum Type {
	OnlineEvent = "EVENT",
	OfflineEvent = "OFFLINE_EVENT",
	Calendar = "CALENDAR",
	CalendarApprove = "CALENDAR_APPROVE",
	Payment = "PAYMENT",
	Voucher = "VOUCHER",
	Holiday = "HOLIDAY",
}

export enum ReminderUnit {
	Minutes = "minutes",
	Hours = "hours",
	Days = "days",
}

export enum Target {
	User = "USER",
	Host = "HOST",
	Admin = "ADMIN",
}

export enum Method {
	Notification = "NOTIFICATION",
	Email = "EMAIL",
	ZNS = "ZNS",
	SMS = "SMS",
}

export enum Status {
	Enabled = "ENABLED",
	Disabled = "DISABLED",
}

export enum SchedulerStatus {
	Pending = "PENDING",
	Running = "RUNNING",
	Completed = "COMPLETED",
	Failed = "FAILED",
}

export enum SchedulerTiming {
	StartTime = "START_TIME",
	EndTime = "END_TIME",
}

export enum SchedulerWhen {
	Before = "BEFORE",
	After = "AFTER",
}
